module.exports = __webpack_public_path__ + "img/not_found.a7f8cdab.svg";